import { useContext } from 'react';
import { ThemeContext } from './ThemeProvider';
import type { ThemeContextValue } from './types';

/**
 * useTheme - Hook to access theme context
 *
 * Provides access to current theme and theme manipulation functions.
 *
 * @throws Error if used outside ThemeProvider
 *
 * @example
 * function MyComponent() {
 *   const { theme, effectiveTheme, setTheme, toggleTheme } = useTheme();
 *
 *   return (
 *     <button onClick={toggleTheme}>
 *       Current theme: {theme} (effective: {effectiveTheme})
 *     </button>
 *   );
 * }
 */
export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
}
